import {
    COMPANIES_ERROR,
    COMPANIES_SUCESS,
    COMPANIES_REQUEST
} from '../actions/companiesActions';

const initialState={
    data:[],
    fetching:false,
    set:false,
}

export default function companies(state = initialState, action){
    switch (action.type){
        case COMPANIES_REQUEST:
            return{
                ...state,
                fetching:true
            }
        case COMPANIES_ERROR:
            return{
                ...state,
                fetching:false,
            }
        case COMPANIES_SUCESS:
            return{
                ...state,
                fetching:false,
                set:true,
                data:action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/companies.js